import qs, {ParsedQs} from 'qs'
import {selectSearchObj, aReplace} from '@modifi/router'
import {ThunkAction, ApplicationState} from '@modifi/redux'
import {createSelector} from 'reselect'
import {DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE, VALID_ITEMS_PER_PAGE_PARAM} from '../constants'
import {selectErrorObject} from './submit'

type MockSelectSearchObj = (state: ApplicationState) => ParsedQs

export const selectFetchParamsFromSearchObject = createSelector(
  selectSearchObj as MockSelectSearchObj,
  searchObject =>
    ({
      pageIndex:
        typeof searchObject.page === 'string' ? parseInt(searchObject.page, 10) - 1 : undefined,
      pageSize:
        typeof searchObject.itemsPerPage === 'string' &&
        VALID_ITEMS_PER_PAGE_PARAM.includes(searchObject.itemsPerPage)
          ? parseInt(searchObject.itemsPerPage, 10)
          : undefined,
      orderBy: searchObject.orderBy ?? undefined,
      orderDirection: searchObject.orderDirection ?? undefined,
    } as {
      pageIndex: number
      pageSize: number
      orderBy?: string[]
      orderDirection?: ('ASC' | 'DESC')[]
    })
)

export const selectKeyWindowFromSearchObject = createSelector(
  selectFetchParamsFromSearchObject,
  fetchParams =>
    ({
      pageIndex: fetchParams.pageIndex ?? DEFAULT_PAGE_INDEX,
      pageSize: fetchParams.pageSize ?? DEFAULT_PAGE_SIZE,
      orderBy: fetchParams.orderBy ?? ['status'],
      orderDirection: fetchParams.orderDirection ?? ['DESC'],
    } as {
      pageIndex: number
      pageSize: number
      orderBy?: string[]
      orderDirection?: ('ASC' | 'DESC')[]
    })
)

export const selectSubmitErrorObject = createSelector(selectErrorObject, errorObject => ({
  errorCode: errorObject?.code ? errorObject.code : undefined,
  errorMessage: errorObject?.message ? errorObject.message : undefined,
}))

const selectHasAllSearchObjectVariables = createSelector(
  selectFetchParamsFromSearchObject,
  fetchParams =>
    !!fetchParams.pageIndex &&
    !!fetchParams.pageSize &&
    !!fetchParams.orderBy &&
    !!fetchParams.orderDirection
)

export const aRedirectWithDefaultQuery =
  (): ThunkAction<any, any, any, any> => (dispatch, getState) => {
    if (!selectHasAllSearchObjectVariables(getState())) {
      const {pageSize, pageIndex} = selectKeyWindowFromSearchObject(getState())
      dispatch(
        aReplace({
          search: qs.stringify({
            page: pageIndex + 1,
            itemsPerPage: pageSize,
          }),
        })
      )
    }
  }
